import { Action, createReducer, on } from '@ngrx/store';
import { LookupValue } from 'src/app/models/lookup.model';
import * as fromPE from '../fromPe.barrel';
import { Application, EquipmentType, Measurement, PEAccessorySelector, PEEquipmentFamily, PEEquipmentProduct, PEEquipmentSelector, PEFitting, PEFilter, PEFittingProduct } from 'src/app/models';


export enum Loaders {
  loadPipeSizes = 'Loading pipe sizes...',
  loadResults = "loadResults",
  loadEquipmentFamilies = "loadEquipmentFamilies",
  loadPEEquipment = "loadPEEquipment",
  loadPEAccessories = "loadPEAccessories",
  loadReport = "loadReport"
}

export const peFeatureKey = 'pe';

export interface State {
  loaders: Loaders[],
  pipeSizes: LookupValue[],
  equipmentFamilies: PEEquipmentFamily[],
  peFilter: PEFilter,
  fittingsResult: PEFittingProduct[],
  activeFittings: PEFittingProduct[],
  activePluggingMachinePartNumber?: string,
  activeTappingMachinePartNumber?: string,
  activeValvePartNumber?: string,
  activeCompletionMachinePartNumber?: string,
  activeAccessoryPartNumbers?: string[],
  // equipmentFilter?: PEEquipmentSelector,
  equipmentResult: PEEquipmentProduct[],
  // accessoryFilter?: PEAccessorySelector,
  accessoryResult: PEEquipmentProduct[]
}

export const initialState: State = {
  loaders: [],
  pipeSizes: [],
  peFilter: { measurement: Measurement.Any, application: Application.Any, sizes: [] },
  fittingsResult: [],
  equipmentFamilies: [],
  equipmentResult: [],
  accessoryResult: [],
  activeAccessoryPartNumbers: [],
  activeFittings: []
};

export const reducer = createReducer(
  initialState,

  on(fromPE.loadPipeSizes, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadPipeSizes)
  })),
  on(fromPE.loadPipeSizesSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPipeSizes),
    pipeSizes: action.pipeSizes
  })),
  on(fromPE.loadPipeSizesFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPipeSizes)
  })),
  on(fromPE.updatePeFilter, (state: State, action) => ({
    ...state,
    peFilter: {
      ...state.peFilter,
      ...action.obj
    }
  })),
  on(fromPE.toggleSizeOnFilter, (state: State, action) => {
    console.log(state.peFilter);
    return ({
      ...state,
      peFilter: {
        ...state.peFilter,
        sizes: (state.peFilter.sizes || []).includes(action.size) ?
          state.peFilter.sizes.filter(f => f !== action.size) :
          state.peFilter.sizes.concat(action.size)
      }
    })
  }),
  on(fromPE.loadFittings, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadResults)
  })),
  on(fromPE.loadFittingsSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadResults),
    fittingsResult: action.fittings
  })),
  on(fromPE.loadFittingsFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadResults)
  })),
  on(fromPE.toggleSelectedFitting, (state: State, action) => ({
    ...state,
    activeFittings: state.activeFittings.map(f => f.partNumber)?.includes(action.obj.partNumber) ?
      state.activeFittings.filter(f => f.partNumber !== action.obj.partNumber) :
      state.activeFittings.concat(action.obj)
  })),
  on(fromPE.clearActiveFittings, (state: State, action) => ({
    ...state,
    activeFittings: []
  })),
  on(fromPE.loadEquipmentFamilies, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadEquipmentFamilies)
  })),
  on(fromPE.loadEquipmentFamiliesSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadEquipmentFamilies),
    equipmentFamilies: action.families
  })),
  on(fromPE.loadEquipmentFamiliesFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadEquipmentFamilies)
  })),
  on(fromPE.updateEquipmentSelections, (state: State, action) => ({
    ...state,
    peFilter: {
      ...state.peFilter,
      ...action.obj,
    }
  })),
  on(fromPE.loadEquipment, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadPEEquipment)
  })),
  on(fromPE.loadEquipmentSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPEEquipment),
    equipmentResult: action.equipment
  })),
  on(fromPE.loadEquipmentFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPEEquipment),
  })),
  on(fromPE.selectEquipment, (state: State, action) => ({
    ...state,
    activeEquipmentPartNumber: action.partNumber
  })),
  on(fromPE.updateAccessorySelections, (state: State, action) => ({
    ...state,
    peFilter: {
      ...state.peFilter,
      ...action.obj
    }
  })),
  on(fromPE.loadAccessory, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadPEAccessories)
  })),
  on(fromPE.loadAccessorySuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPEAccessories),
    accessoryResult: action.accessories
  })),
  on(fromPE.loadAccessoryFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadPEAccessories)
  })),
  on(fromPE.toggleActiveAccessory, (state: State, action) => ({
    ...state,
    activeAccessoryPartNumbers: (state.activeAccessoryPartNumbers || []).includes(action.partNumber) ?
      state.activeAccessoryPartNumbers?.filter(pn => pn !== action.partNumber) :
      state.activeAccessoryPartNumbers?.concat(action.partNumber)
  })),
  on(fromPE.selectEquipment, (state: State, action) => ({
    ...state,
    activePluggingMachinePartNumber: action.equipmentType === EquipmentType.Plugging ? !state.activePluggingMachinePartNumber ? action.partNumber : undefined : state.activePluggingMachinePartNumber,
    activeTappingMachinePartNumber: action.equipmentType === EquipmentType.Tapping ? !state.activeTappingMachinePartNumber ? action.partNumber : undefined : state.activeTappingMachinePartNumber,
    activeValvePartNumber: action.equipmentType === EquipmentType.Valve ? !state.activeValvePartNumber ? action.partNumber : undefined : state.activeValvePartNumber,
    activeCompletionMachinePartNumber: action.equipmentType === EquipmentType.Completion ? !state.activeCompletionMachinePartNumber ? action.partNumber : undefined : state.activeCompletionMachinePartNumber
  })),

  on(fromPE.exportPDF, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadReport)
  })),

  on(fromPE.exportExcel, (state: State, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadReport)
  })),

  on(fromPE.exportPDFSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadReport)
  })),

  on(fromPE.exportExcelSuccess, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadReport)
  })),

  on(fromPE.exportPDFFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadReport)
  })),

  on(fromPE.exportExcelFail, (state: State, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadReport)
  }))


);
